<select [(ngModel)]="groupBy"
  (ngModelChange)="setQueryProps()">
  @for (option of availableGroupBy; track option) {
    <option [ngValue]="option.key">{{option.label}}</option>
  }
</select>

@if (error) {
  <div
    class="op-toast -error">
    <div class="op-toast--content"
      [textContent]="error">
    </div>
  </div>
}

@if (displayMulti) {
  <op-wp-embedded-graph #wpEmbeddedGraphMulti
    [datasets]="datasets"
    [chartOptions]="chartOptions"
     />
}

@if (displaySingle) {
  <op-wp-embedded-graph #wpEmbeddedGraphSingle
    [datasets]="datasets"
    [chartOptions]="chartOptions"
     />
}
